import { apiClient } from '@/shared/api';
import { handleRequest } from '@/shared/api/apiWrapper';

export type InternalTransferRequestParams = {
  accNumFrom: string;
  accNumTo: string;
  assetFrom: string;
  assetTo: string;
  amount: string;
};

export type InternalTransferResponse = {
  autoRefeshCache?: number;
  restsCacheLifeTime?: number;
  operations?: string[];
};

export const createInternalTransfer = async (
  data: InternalTransferRequestParams
): Promise<InternalTransferResponse> => {
  const request = () => apiClient.post('/operations/transfer/toacc', data);
  const response = await handleRequest<InternalTransferResponse>(request);
  return response.data;
};
